const closeButtonLabel = "Cerrar";
const esMX = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  esMX as default
};
